import App from "App";
import MainLayout from "layouts/MainLayout";

import { lazy, Suspense } from "react";
//lazy
import EditarVersao from "pages/admin/editarVersao";
import NovaVersao from "pages/admin/novaVersao";
import ReferenciaAnvisa from "pages/admin/referenciaAnvisa";
import Versoes from "pages/admin/versoes";
import Error403 from "pages/error/Error403";
import Error404 from "pages/error/Error404";
import Error500 from "pages/error/Error500";
import Logs from "pages/overwatch/hub";
import Implantacao from "pages/overwatch/implantacao";
import Licenca from "pages/overwatch/licenca";
import Servidores from "pages/overwatch/servidores";
import ForgotPassword from "pages/pages/authentication/simple/ForgotPassword";
import ForgotPasswordConfirm from "pages/pages/authentication/simple/ForgotPasswordConfirm";
import ResetPassword from "pages/pages/authentication/simple/ResetPassword";
import SignIn from "pages/pages/authentication/simple/SignIn";
import TwoFA from "pages/pages/authentication/simple/TwoFA";
import Departamentos from "pages/retaguarda/departamentos";
import EditarDepartamento from "pages/retaguarda/editarDepartamento";
import EditarEmpresa from "pages/retaguarda/editarEmpresa";
import EditarFabricante from "pages/retaguarda/editarFabricante";
import EditarPrincipioAtivo from "pages/retaguarda/editarPrincipioAtivo";
import EditarProduto from "pages/retaguarda/editarProduto";
import EditarRegraFiscal from "pages/retaguarda/editarRegraFiscal";
import EditarUnidadeDeMedida from "pages/retaguarda/editarUnidadeDeMedida";
import Empresas from "pages/retaguarda/empresas";
import Fabricantes from "pages/retaguarda/fabricantes";
import Home from "pages/retaguarda/home";
import Vendas from "pages/retaguarda/venda";
import NovaRegraFiscal from "pages/retaguarda/novaRegraFiscal";
import NovaUnidadeDeMedida from "pages/retaguarda/novaUnidadeDeMedida";
import NovoDepartamento from "pages/retaguarda/novoDepartamento";
import NovoFabricante from "pages/retaguarda/novoFabricante";
import NovoPrincipioAtivo from "pages/retaguarda/novoPrincipioAtivo";
import NovoProduto from "pages/retaguarda/novoProduto";
import PrincipiosAtivos from "pages/retaguarda/principiosAtivos";
import Produtos from "pages/retaguarda/produtos";
import Promocoes from "pages/retaguarda/promocoes";
import RegrasFiscais from "pages/retaguarda/regrasFiscais";
import UnidadesDeMedida from "pages/retaguarda/unidadesDeMedida";
import Assinatura from "pages/revenda/assinatura";
import Clientes from "pages/revenda/clientes";
import EditarCliente from "pages/revenda/editarCliente";
import NovoCliente from "pages/revenda/novoCliente";
import VersaoTimeline from "pages/revenda/versoes";
import ProtectedRoute from "ProtectedRoute";
import MainLayoutProvider from "providers/MainLayoutProvider";
import NovaPromocao from "pages/retaguarda/novaPromocao";
import EditarPromocao from "pages/retaguarda/editarPromocao";
import { createBrowserRouter, RouteObject } from "react-router-dom";
import Usuarios from "pages/retaguarda/Usuarios";
import NovoUsuario from "pages/retaguarda/novoUsuario";
import EditarUsuario from "pages/retaguarda/editarUsuarios";
import Caixas from "pages/retaguarda/caixa";
import EmpresaProvider from "providers/EmpresaProvider";
import { Spinner } from "react-bootstrap";
import Grupos from "pages/retaguarda/grupos";
import EditarGrupo from "pages/retaguarda/editarGrupo";
import NovoGrupo from "pages/retaguarda/novoGrupo";
import Inutilizacoes from "pages/retaguarda/inutilizacoes";
import NovaInutilizacao from "pages/retaguarda/novaInutilizacao";
import InventarioSngpc from "pages/sngpc/inventario";
import MovimentacaoSngpc from "pages/sngpc/movimentacao";
import BalancoOperacional from "pages/operacional/balanco";
import Medicos from "pages/retaguarda/medicos";
import NovoMedico from "pages/retaguarda/medicos/novo";
import EditarMedico from "pages/retaguarda/medicos/editar";
import Fornecedores from "pages/retaguarda/fornecedores";
import EditarFornecedor from "pages/retaguarda/editarFornecedor";
import NovoFornecedor from "pages/retaguarda/novoFornecedor";
import Meta from "pages/gerencial/meta";
import Contas from "pages/contas";
import ContaDetalhes from "pages/contas/detalhes";
import FormasPagamento from "pages/retaguarda/FormasPagamento";
import NovaFormaPagamento from "pages/retaguarda/novaFormaPagamento";
import EditarFormaPagamento from "pages/retaguarda/editarFormaPagamento";
import Prazos from "pages/retaguarda/Prazos";
import NovoPrazo from "pages/retaguarda/novoPrazo";
import EditarPrazo from "pages/retaguarda/editarPrazo";
import PedidosCompra from "pages/retaguarda/pedidosCompra";
import TabelasPreco from "pages/retaguarda/tabelasPreco";
import TabelaPrecoForm from "pages/retaguarda/tabelaPrecoForm";
import Kits from "pages/retaguarda/kits";
import KitForm from "pages/retaguarda/kitForm";
import NFe from "pages/nfe";
import NovaNFe from "pages/nfe/novo";
import EditarNFe from "pages/nfe/editar";

const routes: RouteObject[] = [
  {
    element: <App />,
    errorElement: <Error500 />,
    children: [
      {
        path: "/",
        element: (
          <MainLayoutProvider>
            <ProtectedRoute
              element={
                <EmpresaProvider>
                  <MainLayout />
                </EmpresaProvider>
              }
            ></ProtectedRoute>
          </MainLayoutProvider>
        ),
        children: [
          {
            path: "/i/:connId",
            element: <Implantacao />,
          },
          {
            path: "/admin",
            children: [
              {
                path: "versoes",
                children: [
                  {
                    element: <Versoes />,
                    index: true,
                  },
                  {
                    path: "novo",
                    element: <NovaVersao />,
                  },
                  {
                    path: ":id",
                    element: <EditarVersao />,
                  },
                ],
              },
              {
                path: "referencia-anvisa",
                element: <ReferenciaAnvisa />,
              },
            ],
          },
          {
            path: "/revenda",
            children: [
              {
                path: "clientes",
                children: [
                  {
                    index: true,
                    element: <Clientes />,
                  },
                  {
                    path: ":id",
                    element: <EditarCliente />,
                  },
                  {
                    path: ":id/assinatura",
                    element: <Assinatura />,
                  },
                  {
                    path: "novo",
                    element: <NovoCliente />,
                  },
                ],
              },
              {
                path: "licenca",
                element: <Licenca />,
              },
              {
                path: "versoes",
                element: <VersaoTimeline />,
              },
            ],
          },
          {
            path: "/overwatch",
            children: [
              {
                path: "logs",
                element: <Logs />,
              },
              {
                path: "servidores",
                element: <Servidores />,
              },
            ],
          },
          {
            path: "/",
            children: [
              {
                index: true,
                element: <Home />,
              },
              {
                path: "cadastros",
                children: [
                  {
                    path: "empresas",
                    children: [
                      {
                        index: true,
                        element: <Empresas />,
                      },
                      {
                        path: ":id",
                        element: <EditarEmpresa />,
                      },
                    ],
                  },
                  {
                    path: "produtos",
                    children: [
                      {
                        index: true,
                        element: <Produtos />,
                      },
                      {
                        path: ":id",
                        element: <EditarProduto />,
                      },
                      {
                        path: "novo",
                        element: <NovoProduto />,
                      },
                    ],
                  },
                  {
                    path: "unidades-de-medida",
                    children: [
                      {
                        index: true,
                        element: <UnidadesDeMedida />,
                      },
                      {
                        path: ":id",
                        element: <EditarUnidadeDeMedida />,
                      },
                      {
                        path: "novo",
                        element: <NovaUnidadeDeMedida />,
                      },
                    ],
                  },
                  {
                    path: "departamentos",
                    children: [
                      {
                        index: true,
                        element: <Departamentos />,
                      },
                      {
                        path: ":id",
                        element: <EditarDepartamento />,
                      },
                      {
                        path: "novo",
                        element: <NovoDepartamento />,
                      },
                    ],
                  },
                  {
                    path: "fabricantes",
                    children: [
                      {
                        index: true,
                        element: <Fabricantes />,
                      },
                      {
                        path: ":id",
                        element: <EditarFabricante />,
                      },
                      {
                        path: "novo",
                        element: <NovoFabricante />,
                      },
                    ],
                  },
                  {
                    path: "medicos",
                    children: [
                      {
                        index: true,
                        element: <Medicos />,
                      },
                      {
                        path: ":id",
                        element: <EditarMedico />,
                      },
                      {
                        path: "novo",
                        element: <NovoMedico />,
                      },
                    ],
                  },
                  {
                    path: "principios-ativos",
                    children: [
                      {
                        index: true,
                        element: <PrincipiosAtivos />,
                      },
                      {
                        path: ":id",
                        element: <EditarPrincipioAtivo />,
                      },
                      {
                        path: "novo",
                        element: <NovoPrincipioAtivo />,
                      },
                    ],
                  },
                  {
                    path: "regras-fiscais",
                    children: [
                      {
                        index: true,
                        element: <RegrasFiscais />,
                      },
                      {
                        path: ":id",
                        element: <EditarRegraFiscal />,
                      },
                      {
                        path: "novo",
                        element: <NovaRegraFiscal />,
                      },
                    ],
                  },
                  {
                    path: "promocoes",
                    children: [
                      {
                        index: true,
                        element: <Promocoes />,
                      },
                      {
                        path: ":id",
                        element: <EditarPromocao />,
                      },
                      {
                        path: "novo",
                        element: <NovaPromocao />,
                      },
                    ],
                  },
                  {
                    path: "usuarios",
                    children: [
                      {
                        index: true,
                        element: <Usuarios />,
                      },
                      {
                        path: ":id",
                        element: <EditarUsuario />,
                      },
                      {
                        path: "novo",
                        element: <NovoUsuario />,
                      },
                    ],
                  },
                  {
                    path: "grupos",
                    children: [
                      {
                        index: true,
                        element: <Grupos />,
                      },
                      {
                        path: ":id",
                        element: <EditarGrupo />,
                      },
                      {
                        path: "novo",
                        element: <NovoGrupo />,
                      },
                    ],
                  },
                  {
                    path: "fornecedores",
                    children: [
                      {
                        index: true,
                        element: <Fornecedores />,
                      },
                      {
                        path: ":id",
                        element: <EditarFornecedor />,
                      },
                      {
                        path: "novo",
                        element: <NovoFornecedor />,
                      },
                    ],
                  },
                  {
                    path: "formas-pagamento",
                    children: [
                      {
                        index: true,
                        element: <FormasPagamento />,
                      },
                      {
                        path: ":id",
                        element: <EditarFormaPagamento />,
                      },
                      {
                        path: "novo",
                        element: <NovaFormaPagamento />,
                      },
                    ],
                  },
                  {
                    path: "prazos",
                    children: [
                      {
                        index: true,
                        element: <Prazos />,
                      },
                      {
                        path: "novo",
                        element: <NovoPrazo />,
                      },
                      {
                        path: ":id",
                        element: <EditarPrazo />,
                      },
                    ],
                  },
                  {
                    path: "tabela-preco",
                    children: [
                      {
                        index: true,
                        element: <TabelasPreco />,
                      },
                      {
                        path: "nova",
                        element: <TabelaPrecoForm />,
                      },
                      {
                        path: ":id",
                        element: <TabelaPrecoForm />,
                      },
                    ],
                  },
                  {
                    path: "kits",
                    children: [
                      {
                        index: true,
                        element: <Kits />,
                      },
                      {
                        path: "novo",
                        element: <KitForm />,
                      },
                      {
                        path: ":id",
                        element: <KitForm />,
                      },
                    ],
                  },
                ],
              },
              {
                path: "operacional",
                children: [
                  {
                    path: "vendas",
                    children: [
                      {
                        index: true,
                        element: <Vendas />,
                      },
                    ],
                  },
                  {
                    path: "caixas",
                    children: [
                      {
                        index: true,
                        element: <Caixas />,
                      },
                    ],
                  },
                  {
                    path: "inutilizacao",
                    children: [
                      {
                        index: true,
                        element: <Inutilizacoes />,
                      },
                      {
                        path: "nova",
                        element: <NovaInutilizacao />,
                      },
                    ],
                  },
                  {
                    path: "nfe",
                    children: [
                      {
                        index: true,
                        element: <NFe />,
                      },
                      {
                        path: "novo",
                        element: <NovaNFe />,
                      },
                      {
                        path: ":id",
                        element: <EditarNFe />,
                      },
                    ],
                  },
                  {
                    path: "balanco",
                    children: [
                      {
                        index: true,
                        element: <BalancoOperacional />,
                      },
                    ],
                  },
                ],
              },
              {
                path: "gerencial",
                children: [
                  {
                    path: "meta",
                    children: [
                      {
                        index: true,
                        element: <Meta />,
                      },
                    ],
                  },
                ]
              },
              {
                path: "sngpc",
                children: [
                  {
                    path: "inventario",
                    element: <InventarioSngpc />,
                  },
                  {
                    path: "movimentacao",
                    element: <MovimentacaoSngpc />,
                  },
                ],
              },
              {
                path: "financeiro",
                children: [
                  {
                    path: "contas",
                    children: [
                      {
                        index: true,
                        element: <Contas />,
                      },
                      {
                        path: ":id",
                        element: <ContaDetalhes />,
                      },
                    ],
                  },
                ],
              },
              {
                path: "pedidos",
                element: <PedidosCompra />,
              },
            ],
          },
        ],
      },
      {
        path: "/pages/errors/",
        children: [
          {
            path: "404",
            element: <Error404 />,
          },
          {
            path: "403",
            element: <Error403 />,
          },
          {
            path: "500",
            element: <Error500 />,
          },
        ],
      },
      {
        path: "/pages/authentication/simple/",
        children: [
          {
            path: "sign-in",
            element: <SignIn />,
          },
          {
            path: "reset-password",
            element: <ResetPassword />,
          },
          {
            path: "2FA",
            element: <TwoFA />,
          },
          {
            path: "forgot-password",
            element: <ForgotPassword />,
          },
          {
            path: "forgot-confirm",
            element: <ForgotPasswordConfirm />,
          },
        ],
      },
      {
        path: "*",
        element: <Error404 />,
      },
    ],
  },
];

export const router = createBrowserRouter(routes);

export default routes;
